import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import { AppVariation } from "src/client-config/getClientConfig.ts";
import type { Module } from "src/system/module.types.ts";
import type { OwnerResource } from "@exonn/js-sdk";

export const module: Module<OwnerResource> = {
  id: ResourceEnum.Owner,
  bigIcon: <span className={"icon-20-customers_lst"} />,
  smallIcon: <span className={"icon-15-customers_lst"} />,
  name: (t: TFunction) => t("moduleName.owners"),

  disableCreate: ({ clientConfig }) =>
    clientConfig.appVariation === AppVariation.B2bGateSupplier,
  disableDelete: ({ clientConfig }) =>
    clientConfig.appVariation === AppVariation.B2bGateSupplier,

  tabs: {
    edit: {
      getTitle: (resource) => resource.company_name,
    },
  },
};
